









import {Prop, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {Widget} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";

const components = {
    Container,
};

@Component({components})

export default class Weather extends Vue {
    @Prop({default: null}) public widget !: Widget;

    public resizeIframe(obj: any) {
        obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + "px";
    }
}
